/* eslint-disable no-param-reassign */

import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { freezeScrollOnNextRender } from 'src/lib/scroll_freeze';

export default class extends Controller {
  static values = {
    target: String,
    baseUrl: String,
  };

  static targets = ['filter', 'resultsLink', 'reset'];

  connect() {
    const url = this.buildQuery();
    this.resultsLinkTarget.href = url;
    this.resultsLinkTarget.dataset.originalUrl = url;
    this.updateResetState();

    this.checkStates = [];
    this.setOriginalCheckStates();
  }

  filterSelect(e) {
    const footer = document.querySelector('.filters-footer');

    if (window.getComputedStyle(footer).display !== 'none') {
      // mobile filters are active
      const url = this.buildQuery();
      this.updateResultsLink(url);
      this.updateResetState();
    } else {
      // desktop filters are active
      const url = e.currentTarget.value;
      this.jump(url);
    }
  }

  jump(url) {
    if (this.hasTargetValue) {
      freezeScrollOnNextRender(this.targetValue);
    }

    Turbo.visit(url);
  }

  buildQuery() {
    const query = [];

    this.filterTargets.forEach((el) => {
      if (el.checked) {
        const { filterGroup, filterValue } = el.dataset;

        query.push([`${filterGroup}[]`, filterValue]);
      }
    });

    let queryString = '';
    query.forEach((pair) => {
      queryString = `${queryString}&${encodeURIComponent(pair[0])}=${encodeURIComponent(pair[1])}`;
    });
    const url = `${this.baseUrlValue}${queryString}`;
    return url;
  }

  updateResultsLink(url) {
    const { originalUrl } = this.resultsLinkTarget.dataset;

    this.resultsLinkTarget.href = url;

    if (originalUrl === url) {
      this.resultsLinkTarget.classList.add('inactive');
      return;
    }

    this.resultsLinkTarget.classList.add('inactive');
    fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    }).then((json) => {
      if (json.results !== 0) {
        this.resultsLinkTarget.text = 'View Results';
        this.resultsLinkTarget.href = url;
        this.resultsLinkTarget.classList.remove('inactive');
      } else {
        this.resultsLinkTarget.text = 'No Results';
        this.resultsLinkTarget.href = url;
        this.resultsLinkTarget.classList.add('inactive');
      }
    });
  }

  updateResetState() {
    let active = false;
    this.filterTargets.forEach((el) => {
      if (el.checked) {
        active = true;
      }
    });

    if (active) {
      this.resetTarget.classList.remove('inactive');
    } else {
      this.resetTarget.classList.add('inactive');
    }
  }

  reset(e) {
    e.preventDefault();

    if (!this.resetTarget.classList.contains('inactive')) {
      this.filterTargets.forEach((el) => {
        el.checked = false;
      });

      const url = this.buildQuery();
      this.updateResultsLink(url);
      this.updateResetState();
    }
  }

  setOriginalCheckStates() {
    this.filterTargets.forEach((el) => {
      if (el.checked) {
        this.checkStates.push(el.id);
      }
    });
  }

  toggle(e) {
    const { contains, toggleClass } = e.detail;

    if (toggleClass !== 'hidden') {
      return;
    }

    if (contains) {
      // modal got hidden

      document.body.style.overflow = 'auto';

      this.filterTargets.forEach((el) => {
        el.checked = this.checkStates.includes(el.id);
      });

      this.resultsLinkTarget.href = this.resultsLinkTarget.dataset.originalUrl;
      this.resultsLinkTarget.classList.add('inactive');
      this.updateResetState();
    } else {
      // modal shown

      document.body.style.overflow = 'hidden';
    }
  }

  beforeCache() {
    document.body.style.overflow = 'auto';
  }
}
